import React, { useState, useEffect } from "react";
import CreatableSelect from 'react-select/creatable';
import Axios from '../../AxiosConfig';

const SelectAndCreate = ({ optionAPI, createAPI, filters, setParent, disabled, defaultValue }) => {
    const createOption = (label) => ({
        label,
        value: label.toLowerCase().replace(/\W/g, ''),
    });
    const [defaultUserValue, setDefaultUserValue] = useState(defaultValue ? createOption(defaultValue) : null);
    const [value, setValue] = useState(undefined);
    const [isLoading, setIsLoading] = useState(true);
    const [options, setOptions] = useState([]);
    useEffect(() => {
        let postData = {}
        if (filters) {
            postData = filters;
        }
        Axios.post(optionAPI, postData).then(data => {
            const _options = data.data.map((d) => createOption(d.name));
            setOptions(_options);
            setIsLoading(false);
        });
    }, []);

    useEffect(() => {
        if (value) {
            setParent(value.label);
        } else {
            setParent(null)
        }
    }, [value]);
    useEffect(() => {
        if (defaultUserValue) {
            setParent(defaultUserValue.label);
        }
    }, [defaultUserValue]);

    const handleChange = (
        newValue
    ) => {
        setValue(newValue);
    };
    const handleCreate = (inputValue) => {
        setIsLoading(true);
        let postData = {}
        if (filters) {
            postData = filters;
        }
        postData["name"] = inputValue;
        Axios.post(createAPI, postData).then(data => {
            const newOption = createOption(inputValue);
            setOptions([...options, newOption]);
            setValue(newOption);
            setIsLoading(false);
        });
    };
    return (
        <CreatableSelect
            isClearable
            isDisabled={isLoading || disabled}
            isLoading={isLoading}
            onChange={handleChange}
            onCreateOption={handleCreate}
            options={options}
            value={value}
            defaultValue={defaultUserValue}
            menuPlacement="auto"
            menuPortalTarget={document.body}
            styles={{
                menuPortal: defaultStyles => ({
                    ...defaultStyles,
                    paddingBottom: '10px',
                    marginTop: '0px',
                    zIndex: 9999,
                }),
            }}
        />
    )
}
export default SelectAndCreate;